import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Download, X } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt.js';

export function InstallBanner() {
  const { canInstall, install } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  // Klanten op de oude portaallink niet aansporen tot installeren; de klant-app wordt /mijn.
  if (!canInstall || dismissed || pathname.startsWith('/portaal/')) return null;

  // Enkel op gsm-breedte: op desktop bedekte de balk tabellen.
  return (
    <div className="md:hidden fixed bottom-[calc(var(--k-voet)+1rem)] left-4 right-4 z-[9998] bg-brand-secondary text-white rounded-2xl p-4 shadow-2xl flex items-center gap-3 max-w-md mx-auto safe-bottom">
      <div className="w-10 h-10 rounded-xl bg-brand flex items-center justify-center flex-shrink-0">
        <Download size={20} className="text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-sm">Installeer Kordaro</p>
        <p className="text-xs text-gray-400">Snelle toegang vanaf je startscherm</p>
      </div>
      <button
        onClick={install}
        className="bg-brand text-white text-sm font-medium px-4 py-2 rounded-xl active:scale-95 transition-transform"
      >
        Installeer
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="p-1 text-gray-500 hover:text-white"
      >
        <X size={16} />
      </button>
    </div>
  );
}
